import React from 'react';
import PropTypes from 'prop-types';

import './Notification.sass';

export default function Notification({children, onClose}) {
  return (
    <div className="notification">
      <div className="notification__content">
        {children}
      </div>
      {onClose && (
        <button type='button' className="notification__close" onClick={onClose}>
          <span className="notification__close-icon"/>
        </button>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./components/notification/Notification.js